
import { WorldCountry } from '../types';

export const southAfricaExpanded3: WorldCountry = {
  code: 'ZA',
  name: 'South Africa',
  slug: 'south-africa',
  population: 59308690,
  topCities: [
    // Ciudades principales existentes
    { name: 'Cape Town', slug: 'cape-town', population: 4618000 },
    { name: 'Johannesburg', slug: 'johannesburg', population: 4434827 },
    { name: 'Durban', slug: 'durban', population: 3442361 },
    { name: 'Pretoria', slug: 'pretoria', population: 2473000 },
    { name: 'Port Elizabeth', slug: 'port-elizabeth', population: 1244900 },
    { name: 'Bloemfontein', slug: 'bloemfontein', population: 747431 },
    { name: 'East London', slug: 'east-london', population: 478676 },
    { name: 'Nelspruit', slug: 'nelspruit', population: 288842 },
    { name: 'Kimberley', slug: 'kimberley', population: 225160 },
    { name: 'Polokwane', slug: 'polokwane', population: 220000 },
    
    // Nuevas ciudades - Expansión Fase 9
    { name: 'Pietermaritzburg', slug: 'pietermaritzburg', population: 618000 },
    { name: 'Rustenburg', slug: 'rustenburg', population: 550000 },
    { name: 'Witbank', slug: 'witbank', population: 470000 },
    { name: 'Vereeniging', slug: 'vereeniging', population: 450000 },
    { name: 'Klerksdorp', slug: 'klerksdorp', population: 400000 },
    { name: 'Welkom', slug: 'welkom', population: 350000 },
    { name: 'Newcastle', slug: 'newcastle-sa', population: 330000 },
    { name: 'Springs', slug: 'springs', population: 320000 },
    { name: 'Vanderbijlpark', slug: 'vanderbijlpark', population: 310000 },
    { name: 'Benoni', slug: 'benoni', population: 300000 },
    { name: 'Boksburg', slug: 'boksburg', population: 290000 },
    { name: 'Potchefstroom', slug: 'potchefstroom', population: 280000 },
    { name: 'Germiston', slug: 'germiston', population: 270000 },
    { name: 'Kroonstad', slug: 'kroonstad', population: 260000 },
    { name: 'Middelburg', slug: 'middelburg-sa', population: 250000 },
    { name: 'Stellenbosch', slug: 'stellenbosch', population: 240000 },
    { name: 'George', slug: 'george-sa', population: 230000 },
    { name: 'Secunda', slug: 'secunda', population: 220000 },
    { name: 'Paarl', slug: 'paarl', population: 210000 },
    { name: 'Somerset West', slug: 'somerset-west', population: 200000 },
    { name: 'Sasolburg', slug: 'sasolburg', population: 190000 },
    { name: 'Alberton', slug: 'alberton', population: 180000 },
    { name: 'Worcester', slug: 'worcester-sa', population: 170000 },
    { name: 'Randburg', slug: 'randburg', population: 160000 },
    { name: 'Sandton', slug: 'sandton', population: 155000 },
    { name: 'Centurion', slug: 'centurion', population: 150000 },
    { name: 'Roodepoort', slug: 'roodepoort', population: 145000 },
    { name: 'Edenvale', slug: 'edenvale', population: 140000 },
    { name: 'Kempton Park', slug: 'kempton-park', population: 135000 },
    { name: 'Brakpan', slug: 'brakpan', population: 130000 },
    { name: 'Standerton', slug: 'standerton', population: 125000 },
    { name: 'Bloemhof', slug: 'bloemhof', population: 120000 },
    { name: 'Vredendal', slug: 'vredendal', population: 115000 },
    { name: 'Mossel Bay', slug: 'mossel-bay', population: 110000 },
    { name: 'Oudtshoorn', slug: 'oudtshoorn', population: 105000 },
    { name: 'Richards Bay', slug: 'richards-bay', population: 100000 },
    { name: 'Upington', slug: 'upington', population: 95000 },
    { name: 'Bethlehem', slug: 'bethlehem-sa', population: 90000 },
    { name: 'Ladysmith', slug: 'ladysmith', population: 85000 },
    { name: 'Hermanus', slug: 'hermanus', population: 80000 },
    { name: 'Knysna', slug: 'knysna', population: 75000 },
    { name: 'Plettenberg Bay', slug: 'plettenberg-bay', population: 70000 },
    { name: 'Grahamstown', slug: 'grahamstown', population: 65000 },
    { name: 'Beaufort West', slug: 'beaufort-west', population: 60000 },
    { name: 'Caledon', slug: 'caledon', population: 55000 },
    { name: 'Swellendam', slug: 'swellendam', population: 50000 },
    { name: 'Robertson', slug: 'robertson', population: 48000 },
    { name: 'Montagu', slug: 'montagu', population: 46000 },
    { name: 'Ceres', slug: 'ceres', population: 44000 },
    { name: 'Wellington', slug: 'wellington-sa', population: 42000 },
    { name: 'Tulbagh', slug: 'tulbagh', population: 40000 },
    { name: 'Bredasdorp', slug: 'bredasdorp', population: 38000 },
    { name: 'Riversdale', slug: 'riversdale', population: 36000 },
    { name: 'Still Bay', slug: 'still-bay', population: 34000 },
    { name: 'Ladismith', slug: 'ladismith', population: 32000 },
    { name: 'Calitzdorp', slug: 'calitzdorp', population: 30000 },
    { name: 'Prince Albert', slug: 'prince-albert', population: 28000 },
    { name: 'De Rust', slug: 'de-rust', population: 26000 },
    { name: 'Uniondale', slug: 'uniondale', population: 24000 },
    { name: 'Willowmore', slug: 'willowmore', population: 22000 },
    { name: 'Steytlerville', slug: 'steytlerville', population: 20000 },
    { name: 'Jansenville', slug: 'jansenville', population: 18000 },
    { name: 'Graaff-Reinet', slug: 'graaff-reinet', population: 16000 },
    { name: 'Aberdeen', slug: 'aberdeen-sa', population: 14000 },
    { name: 'Pearston', slug: 'pearston', population: 12000 },
    { name: 'Somerset East', slug: 'somerset-east', population: 11000 },
    { name: 'Bedford', slug: 'bedford-sa', population: 10000 },
    { name: 'Adelaide', slug: 'adelaide-sa', population: 9500 },
    { name: 'Fort Beaufort', slug: 'fort-beaufort', population: 9000 },
    { name: 'Alice', slug: 'alice-sa', population: 8500 },
    { name: 'Stutterheim', slug: 'stutterheim', population: 8000 },
    { name: 'Cathcart', slug: 'cathcart', population: 7500 },
    { name: 'Queenstown', slug: 'queenstown-sa', population: 7000 },
    { name: 'Cofimvaba', slug: 'cofimvaba', population: 6500 },
    { name: 'Elliot', slug: 'elliot', population: 6000 },
    { name: 'Maclear', slug: 'maclear', population: 5500 },
    { name: 'Ugie', slug: 'ugie', population: 5000 },
    { name: 'Mount Fletcher', slug: 'mount-fletcher', population: 4800 },
    { name: 'Barkly East', slug: 'barkly-east', population: 4600 },
    { name: 'Rhodes', slug: 'rhodes-sa', population: 4400 },
    { name: 'Lady Grey', slug: 'lady-grey', population: 4200 },
    { name: 'Aliwal North', slug: 'aliwal-north', population: 4000 },
    { name: 'Burgersdorp', slug: 'burgersdorp', population: 3800 },
    { name: 'Steynsburg', slug: 'steynsburg', population: 3600 },
    { name: 'Venterstad', slug: 'venterstad', population: 3400 },
    { name: 'Hofmeyr', slug: 'hofmeyr', population: 3200 },
    { name: 'Colesberg', slug: 'colesberg', population: 3000 },
    { name: 'Noupoort', slug: 'noupoort', population: 2800 },
    { name: 'Hanover', slug: 'hanover-sa', population: 2600 },
    { name: 'Richmond', slug: 'richmond-sa', population: 2400 },
    { name: 'De Aar', slug: 'de-aar', population: 2200 },
    { name: 'Britstown', slug: 'britstown', population: 2000 },
    { name: 'Carnarvon', slug: 'carnarvon-sa', population: 1800 },
    { name: 'Williston', slug: 'williston', population: 1600 },
    { name: 'Fraserburg', slug: 'fraserburg', population: 1400 },
    { name: 'Sutherland', slug: 'sutherland', population: 1200 },
    { name: 'Calvinia', slug: 'calvinia', population: 1000 }
  ]
};
